import React, { useEffect, useState } from 'react';
import axios  from 'axios';
import { variables } from './Variables.js';
export default function Most_View_Ar() {
  const jsonbasket = variables.basename_url + 'updates/index/Coinsinsight_HomeAr_MostViewed.json';
  const [isLoading, setNisLoading] = useState(false);
  async function refda() {

    //  To Show or Hidden Header And Footer
    document.getElementById('Arabic_Header').hidden = false;
    document.getElementById('Arabic_Footer').hidden = false;
    setNisLoading(true);
    Get_Data_basket();
  };

  useEffect(() => {
    setNisLoading(true);
    refda();
  }, [])
  const [JsonArray, setJsonArray] = React.useState([]);
  async function Get_Data_basket() {
    JsonArray.splice(0);  //to clear All data in your page
    setNisLoading(true);
    axios.get(jsonbasket)
      .then(function (response) {
        setNisLoading(false);
        console.log(response.data);
        for (let i = 0; i <= 4 && i < response.data.length; i++) {
          JsonArray.push({
            news_title: response.data[i].news_title,
            news_date: response.data[i].news_date.split('T')[0],
            news_imageName: response.data[i].Image,
            link: response.data[i].link,
            // Description:response.data[i].Description.replace("https://menafn.com/",variables.domain_name + "/") .replace("https://menafn.com",variables.domain_name  ) .replace("MENAFN",variables.domain) .replace("MENAFN",variables.domain)  ,
            Category: response.data[i].Category,

          })
        }
      })
  }
  return (
    <>
      <div className="trending-sidebar-slider slick-initialized slick-slider">
        <div className="slick-list draggable toarabic">
          <div className="slick-track"  >
            <div className="post_gallery_items slick-slide slick-cloned" style={{ width: '350px' }} tabIndex={-1} data-slick-index={3} aria-hidden="true">
              {JsonArray.map(da =>
                <div key={da.news_title}  >
                  <div className="gallery_item gallery_item-style-2 mt-2">
                    <div className="gallery_item_thumb ">
                      <a href={da.link}>
                        <img style={{ maxWidth: '84px', minWidth: '84px', maxHeight: '64px', minHeight: '64px' }} src={da.news_imageName} alt="gallery" />
                      </a>
                    </div>
                    <div className="gallery_item_content mr-3">
                      <div className="post-meta  ">

                       
                        <div className="meta-categories">
                          <a tabIndex={-1}>{da.Category}</a>
                        </div>
                         <div className="meta-date">
                          <span>{da.news_date}</span>
                        </div>
                      </div>
                      <h4 className="title "><a href={da.link} tabIndex={-1}>{da.news_title}</a></h4>
                    </div>
                    
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}



